import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ISnackbarMessage, NHASnackbarComponent } from '@nha/components/snack-bar/snack-bar.component';

@Injectable({
	providedIn: 'root'
})
export class NHASnackbarService {
	private snackBar = inject(MatSnackBar);

	defaultConfig = { duration: 3000 };
	private readonly _snackQueue = new Subject<() => MatSnackBarRef<NHASnackbarComponent>>();

	constructor() {
		this._snackQueue
			.asObservable()
			.pipe(mergeMap((message) => message().afterDismissed(), 1))
			.subscribe();
	}

	success(
		message: string,
		action: string = 'Dismiss',
		config: MatSnackBarConfig<ISnackbarMessage> = this.defaultConfig,
		isHtml: boolean = false
	): MatSnackBarRef<NHASnackbarComponent> {
		config.panelClass = 'success';
		return this.open(message, action, 'success', config, isHtml);
	}

	error(
		message: string,
		action: string = 'Dismiss',
		config: MatSnackBarConfig<ISnackbarMessage> = this.defaultConfig,
		isHtml: boolean = false
	): MatSnackBarRef<NHASnackbarComponent> {
		config.panelClass = 'error';
		return this.open(message, action, 'error', config, isHtml);
	}

	info(
		message: string,
		action: string = 'Dismiss',
		config: MatSnackBarConfig<ISnackbarMessage> = this.defaultConfig,
		isHtml: boolean = false
	): MatSnackBarRef<NHASnackbarComponent> {
		config.panelClass = 'primary';
		return this.open(message, action, 'primary', config, isHtml);
	}

	warn(
		message: string,
		action: string = 'Dismiss',
		config: MatSnackBarConfig<ISnackbarMessage> = this.defaultConfig,
		isHtml: boolean = false
	): MatSnackBarRef<NHASnackbarComponent> {
		config.panelClass = 'warning';
		return this.open(message, action, 'warning', config, isHtml);
	}

	open(
		message: string,
		action: string = 'Dismiss',
		type: string = '',
		config?: MatSnackBarConfig<ISnackbarMessage>,
		isHtml: boolean = false
	): MatSnackBarRef<NHASnackbarComponent> {
		config = { ...config, panelClass: [type, 'nha-snackbar-panel'], data: { message: message, action: action, isHtml: isHtml } };
		return this.snackBar.openFromComponent(NHASnackbarComponent, config);
	}

	queueMessage(creator: () => MatSnackBarRef<NHASnackbarComponent>): void {
		this._snackQueue.next(creator);
	}
}
